import { render, staticRenderFns } from "./GFLoan.vue?vue&type=template&id=79ccb5ea"
import script from "./GFLoan.vue?vue&type=script&lang=js"
export * from "./GFLoan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports